import React from 'react';
import { TableCell as MUITableCell } from '@mui/material';
import { type TableColumn } from 'src/shared/components/Table/Table/types';

export type HeaderCellProps<T> = {
  column: TableColumn<T>;
};

export const HeaderCell = <T,>({ column }: HeaderCellProps<T>) => {
  const getContent = () => {
    if (column.renderHeaderCell) {
      return column.renderHeaderCell();
    }
    return column.title;
  };
  return (
    <MUITableCell key={column.accessor} {...column.headerCellProps}>
      {getContent()}
    </MUITableCell>
  );
};
